module.exports = __webpack_public_path__ + "img/internet.527be2c4.svg";